import { withoutSpace } from '../helpers.mjs';

const conditionsStr = "_hover,_focus,_focusWithin,_focusVisible,_disabled,_active,_visited,_target,_readOnly,_readWrite,_empty,_checked,_enabled,_expanded,_highlighted,_complete,_incomplete,_dragging,_before,_after,_firstLetter,_firstLine,_marker,_selection,_file,_backdrop,_first,_last,_only,_even,_odd,_firstOfType,_lastOfType,_onlyOfType,_peerFocus,_peerHover,_peerActive,_peerFocusWithin,_peerFocusVisible,_peerDisabled,_peerChecked,_peerInvalid,_peerExpanded,_peerPlaceholderShown,_groupFocus,_groupHover,_groupActive,_groupFocusWithin,_groupFocusVisible,_groupDisabled,_groupChecked,_groupExpanded,_groupInvalid,_indeterminate,_required,_valid,_invalid,_autofill,_inRange,_outOfRange,_placeholder,_placeholderShown,_pressed,_selected,_grabbed,_underValue,_overValue,_atValue,_default,_optional,_open,_closed,_fullscreen,_loading,_hidden,_current,_currentPage,_currentStep,_today,_unavailable,_rangeStart,_rangeEnd,_now,_topmost,_motionReduce,_motionSafe,_print,_landscape,_portrait,_dark,_light,_osDark,_osLight,_highContrast,_lessContrast,_moreContrast,_ltr,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_horizontal,_vertical,_icon,_starting,_notDisabled,_groupNotDisabled,_hasActive,_hoverMouse,_hoverNotDisabled,sm,smOnly,smDown,md,mdOnly,mdDown,zDocsSm,zDocsSmOnly,zDocsSmDown,zDocsMd,zDocsMdOnly,zDocsMdDown,lg,lgOnly,lgDown,zDocsLg,zDocsLgOnly,zDocsLgDown,xl,xlOnly,xlDown,zDocsXl,zDocsXlOnly,zDocsXlDown,xxl,xxlOnly,xxlDown,zDocsXxl,zDocsXxlOnly,zDocsXxlDown,smToMd,smToZDocsSm,smToZDocsMd,smToLg,smToZDocsLg,smToXl,smToZDocsXl,smToXxl,smToZDocsXxl,mdToZDocsSm,mdToZDocsMd,mdToLg,mdToZDocsLg,mdToXl,mdToZDocsXl,mdToXxl,mdToZDocsXxl,zDocsSmToZDocsMd,zDocsSmToLg,zDocsSmToZDocsLg,zDocsSmToXl,zDocsSmToZDocsXl,zDocsSmToXxl,zDocsSmToZDocsXxl,zDocsMdToLg,zDocsMdToZDocsLg,zDocsMdToXl,zDocsMdToZDocsXl,zDocsMdToXxl,zDocsMdToZDocsXxl,lgToZDocsLg,lgToXl,lgToZDocsXl,lgToXxl,lgToZDocsXxl,zDocsLgToXl,zDocsLgToZDocsXl,zDocsLgToXxl,zDocsLgToZDocsXxl,xlToZDocsXl,xlToXxl,xlToZDocsXxl,zDocsXlToXxl,zDocsXlToZDocsXxl,xxlToZDocsXxl,_themeLegacy-zillow,_themeZillow,base"
const conditions = new Set(conditionsStr.split(','))

const conditionRegex = /^@|&|&$/

export function isCondition(value){
  return conditions.has(value) || conditionRegex.test(value)
}

const underscoreRegex = /^_/
const conditionsSelectorRegex = /&|@/

export function finalizeConditions(paths){
  return paths.map((path) => {
    if (conditions.has(path)){
      return path.replace(underscoreRegex, '')
    }

    if (conditionsSelectorRegex.test(path)){
      return `[${withoutSpace(path.trim())}]`
    }

    return path
  })}

  export function sortConditions(paths){
    return paths.sort((a, b) => {
      const aa = isCondition(a)
      const bb = isCondition(b)
      if (aa && !bb) return 1
      if (!aa && bb) return -1
      return 0
    })
  }